export default __webpack_public_path__ + "static/media/play_active.61d9807d.svg";